import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "When you don't think you're good enough",
  "description": "",
  "published": "2019-01-21T00:00:00.000Z",
  "redirect_from": ["/blog/when-you-dont-think-youre-good-enough/swizec/8881"],
  "categories": "Learning, Personal",
  "hero": "./img/wikipedia-commons-a-a9-Empirical_Rule.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Here is something true: You are not the best engineer.`}</p>
    <p>{`Here is also something true: You are not the worst engineer.`}</p>
    <p>{`You're about average. Almost everyone is. You know how I know? Stats.`}</p>
    <p>{`Let's assume engineering skill follows a normal distribution from crazy bad to super good. It skews to the good side because very bad engineers aren't likely to get hired and don't keep jobs for long.`}</p>
    <p>{`Normal distribution looks like this 👇`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "769px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/fbf5cf5c94771108b11e938daa61e6c9/227ba/wikipedia-commons-a-a9-Empirical_Rule.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.6457399103139%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'290\\'%20viewBox=\\'0%200%20400%20290\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%20139v125l1-84%201-121V22h46a1184%201184%200%2000-44-2c-2%200-2%200-2-3l-1-3-1%20125M380%2018c0%203%200%203-3%202h-2l-43%201-43%201h43a233%20233%200%200144%201c4-4%204-6%204%20120V18m-72%2028c0%203-1%204-3%202h-1l-21%201-22%201h21l22%201%202%201c2-1%202-1%202%2099a6184%206184%200%20000-105m-57%2036c0%203%200%203-2%202h-2l-9%201c-13%200-11%201%202%201h11v52c0%2051%200%2051%201%2020a716%20716%200%2000-1-76m-57%2030c-11%205-20%2020-32%2053-21%2055-27%2065-45%2077-22%2014-45%2020-91%2023-16%201-21%202-10%202%206%200%207%200%207%202l-5%201-6%201%20189%201a6723%206723%200%2000184-2l-5-1c0-2%202-2%206-2%209%200%205-1-11-2-49-3-72-10-95-26-13-9-21-24-35-62-11-29-16-42-22-50-10-15-19-20-29-15m-1%201c-9%205-18%2021-32%2058l-10%2026v73h50v-27l-1-79c0-57%200-53-7-51m9%2061l1%2079v17h48v-37l-1-37-8-22c-15-42-22-55-33-60-8-4-7-9-7%2060m-56%2034a79%2079%200%2001-46%2045l-6%202v15h56v-69l-4%207m106%2027v35h56v-15l-7-2a79%2079%200%2001-46-45l-3-7v34M86%20258c-11%203-41%208-52%208-6%200-9%201-9%203l34%201h33v-7l-1-7-5%202m224%205v7h35l34-1c0-2-2-2-17-4-19-1-42-5-50-9-2%200-2%201-2%207\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/fbf5cf5c94771108b11e938daa61e6c9/ca0a1/wikipedia-commons-a-a9-Empirical_Rule.webp 223w", "/static/fbf5cf5c94771108b11e938daa61e6c9/75680/wikipedia-commons-a-a9-Empirical_Rule.webp 445w", "/static/fbf5cf5c94771108b11e938daa61e6c9/85eee/wikipedia-commons-a-a9-Empirical_Rule.webp 769w"],
              "sizes": "(max-width: 769px) 100vw, 769px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/fbf5cf5c94771108b11e938daa61e6c9/e92b6/wikipedia-commons-a-a9-Empirical_Rule.png 223w", "/static/fbf5cf5c94771108b11e938daa61e6c9/e66bf/wikipedia-commons-a-a9-Empirical_Rule.png 445w", "/static/fbf5cf5c94771108b11e938daa61e6c9/227ba/wikipedia-commons-a-a9-Empirical_Rule.png 769w"],
              "sizes": "(max-width: 769px) 100vw, 769px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/fbf5cf5c94771108b11e938daa61e6c9/227ba/wikipedia-commons-a-a9-Empirical_Rule.png",
              "alt": "wikipedia commons a a9 Empirical Rule",
              "title": "wikipedia commons a a9 Empirical Rule",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><em parentName="p">{`The`}</em>{` average engineer is that mid point. Very thin slice. I don't think such a person exists. Just like the `}<a parentName="p" {...{
        "href": "https://www.statista.com/statistics/183648/average-size-of-households-in-the-us/"
      }}>{`average American household is 2.53 people`}</a>{` and I have yet to see a 0.53 person walking around.`}</p>
    <p>{`What people `}<em parentName="p">{`mean`}</em>{` when they say "about average" or just "average", is the 1 standard deviation spread. That's 68%.`}</p>
    <p>{`Well … they tend to think of "modus" (the most observed value) when thinking of the average engineer and that's due to `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Representativeness_heuristic"
      }}>{`representation bias`}</a>{`.`}</p>
    <p>{`Anyway, `}<strong parentName="p">{`68% of engineers are average`}</strong>{`. `}<em parentName="p">{`Most`}</em>{` engineers are average.`}</p>
    <p>{`Therefore, it is safe to assume you are average, too.`}</p>
    <p>{`Did you know that 80% of people asked about their driving skill say they're better than average? Yep, `}<a parentName="p" {...{
        "href": "https://www.ncbi.nlm.nih.gov/pubmed/3730094"
      }}>{`80% of drivers think they're above average`}</a>{`.`}</p>
    <p>{`Doesn't compute, does it?`}</p>
    <p>{`Grab two standard deviations and you've got 95% of the population. That is literally almost everyone.`}</p>
    <p>{`Why am I telling you this? Because it's important.`}</p>
    <h2 {...{
      "id": "impostor-syndrome-and-you"
    }}>{`Impostor syndrome and you`}</h2>
    <p>{`Wikipedia describes `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Impostor_syndrome"
      }}>{`impostor syndrome`}</a>{` as`}</p>
    <blockquote>
      <p parentName="blockquote">{`a psychological pattern in which an individual doubts their accomplishments and has a persistent internalized fear of being exposed as a "fraud". Despite external evidence of their competence, those experiencing this phenomenon remain convinced that they are frauds, and do not deserve all they have achieved.`}</p>
    </blockquote>
    <p>{`I get this a lot. It comes out in tweets where I am flabbergasted that people walk up to me and say things like, `}<em parentName="p">{`"Dude, I love your newsletter. It's really helped me a lot. Please keep going.”`}</em></p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`The weirdest part of giving s talk at `}<a parentName="p" {...{
          "href": "https://twitter.com/rwreact"
        }}>{`@rwreact`}</a>{` last night was how many people came up to me and said they read my emails, blogs, etc.`}<br parentName="p"></br><br parentName="p"></br>{`And by many I mean like 5. That’s a lot! Always gobsmacked to find out there’s real people out there on the other end of the internets.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1086331894600331264"
      }}>{`January 18, 2019`}</a></blockquote>
    <p><em parentName="p">{`Everyone gets impostor syndrome`}</em>{`. It's normal. You get it most when you are surrounded by people who know more than you about something.`}</p>
    <p>{`You know what else you get when surrounded by people who know more than you? Growth.`}</p>
    <p>{`Just like when people say that you often don't recognize opportunity when it comes knocking because it's wearing overalls and looks like work. So too you often shy away from opportunity because you're not sure you can handle it.`}</p>
    <p>{`Fuck that. Yes, you can. You can grab the bull by the horns and Figure It Out.`}</p>
    <p>{`That's your greatest superpower as an engineer. Figuring shit out.`}</p>
    <p>{`You take a problem you've never solved before and you solve it. That's what engineers do.`}</p>
    <p>{`Impostor syndrome is your friend. That annoying friend who reminds you that you're about to do something hard, something you've never done before, and what's worse, you're surrounded by experts who could do it ever so easily.`}</p>
    <p>{`But you know what?`}</p>
    <p>{`If you're surrounded by experts, that means you've got someone to ask. You're gonna do just fine.`}</p>
    <p>{`And remember, just because they know more than you about one thing doesn't mean they know more than you about all things. They don't.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.ac4d.com/b/wp-content/uploads/2018/11/What-I-know_1920x1080-1-1024x577.jpg",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "so-what-do-you-do-when-you-dont-think-youre-good-enough"
    }}>{`So what do you do when you don't think you're good enough?`}</h2>
    <p>{`Acknowledge that you feel this way. Think about why you feel this way. Then do the things.`}</p>
    <p>{`Don't know how to do it? Learn.`}</p>
    <p>{`Team better than you? Great! Ask questions. Use your team as a resource.`}</p>
    <p>{`Stuck and nothing works? Breathe, take a break, try a different approach.`}</p>
    <p>{`Anxiety? That's tough. Here's what helps 👇`}</p>
    <p>{`Build a portfolio of successes. Every time you complete a difficult project, write it down. Just a note in a file, a couple of words in a writeup, perhaps. What made it hard, how did you solve it, what obstacles did you overcome?`}</p>
    <p><strong parentName="p">{`Challenge!`}</strong>{` Write down 5 accomplishments from the past few years. Think hard. What are the 5 things you're most proud of building?`}</p>
    <p>{`Awesome! You got it.`}</p>
    <p>{`Next time you feel like you're struggling, go back and read those 5 accomplishments. Keep adding new ones.`}</p>
    <p>{`Remind yourself how good you are when times are tough and motivation is low.`}</p>
    <p>{`✌️`}</p>
    <h1 {...{
      "id": "in-other-news"
    }}>{`In other news`}</h1>
    <p>{`First talk of the year! Gave a talk at the `}<a parentName="p" {...{
        "href": "https://www.meetup.com/Real-World-React/events/256448268/"
      }}>{`Real World React Meetup this week`}</a>{` about my experience building a #24hrstartup.`}</p>
    <p>{`Really, it was more about how amazing the web has gotten and you can be crazy productive and everything is awesome and this is the best time ever to be a frontend engineer.`}</p>
    <p>{`Talk wasn't recorded, but a few people came up to me afterwards and said it reminded them of this much better talk from Chris Coyier.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Your talk was excellent and inspiring. Reminded me this talk at `}<a parentName="p" {...{
          "href": "https://twitter.com/jamstackconf"
        }}>{`@jamstackconf`}</a>{` by `}<a parentName="p" {...{
          "href": "https://twitter.com/chriscoyier"
        }}>{`@chriscoyier`}</a>{`  `}<a parentName="p" {...{
          "href": "https://t.co/WbZ0TuwXfX"
        }}>{`https://t.co/WbZ0TuwXfX`}</a></p>{`— Joel McKinnon (@JoelGMcKinnon) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/JoelGMcKinnon/status/1086337624791441409"
      }}>{`January 18, 2019`}</a></blockquote>
    <lite-youtube {...{
      "videoid": "grSxHfGoaeg",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Oh, and React for Data Visualization is going okay. We're at 77 videos, and I really need to wrap up and launch this thing.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Just finished video 77 of React for Data Visualization.`}<br parentName="p"></br><br parentName="p"></br>{`Remind me to make smaller courses in the future `}<a parentName="p" {...{
          "href": "https://t.co/xIM4L9pfLh"
        }}>{`pic.twitter.com/xIM4L9pfLh`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1084956382153961473"
      }}>{`January 14, 2019`}</a></blockquote>
    <h1 {...{
      "id": "some-things-i-learned-this-week"
    }}>{`Some things I learned this week`}</h1>
    <p>{`My #200wordsTIL practice of learning something new every day and writing a Twitter thread has been going great. Only missed 1 day so far and that was because I went drinking after the meetup on Thursday. Oops.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Today I learned about the wonderful magic of `}<a parentName="p" {...{
          "href": "https://twitter.com/auth0"
        }}>{`@auth0`}</a>{`. `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/200wordsTIL?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#200wordsTIL`}</a><br parentName="p"></br><br parentName="p"></br>{`In just 46 minutes we got an authentication flow working for a `}<a parentName="p" {...{
          "href": "https://twitter.com/GatsbyJS"
        }}>{`@gatsbyjs`}</a>{` site. No backend required.`}<br parentName="p"></br><br parentName="p"></br>{`👇`}<a parentName="p" {...{
          "href": "https://t.co/6Wyndlun2p"
        }}>{`https://t.co/6Wyndlun2p`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1085071994196877312"
      }}>{`January 15, 2019`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Today I spent all day trying to figure out one single function on our backend. The one that hundreds of SQL queries to do one little thing. `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/200wordsTIL?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#200wordsTIL`}</a><br parentName="p"></br><br parentName="p"></br>{`👉 `}<a parentName="p" {...{
          "href": "https://t.co/q9F5ADa6cV"
        }}>{`https://t.co/q9F5ADa6cV`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1085440195179114497"
      }}>{`January 16, 2019`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Start with Why isn't necessarily something I learned today, it's something remind myself of every time I work on a new talk, workshop, or really any content.`}<br parentName="p"></br><br parentName="p"></br>{`This is the best 18 minutes you can spend on YouTube. Ever. `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/200wordsTIL?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#200wordsTIL`}</a><br parentName="p"></br><br parentName="p"></br>{`👇`}<a parentName="p" {...{
          "href": "https://t.co/ITJyRmENHr"
        }}>{`https://t.co/ITJyRmENHr`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1085799975735291904"
      }}>{`January 17, 2019`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Yesterday I learned a lot of weird stuff about Unicode from `}<a parentName="p" {...{
          "href": "https://twitter.com/bobthecow"
        }}>{`@bobthecow`}</a>{` which is perhaps the coolest Twitter handle I have ever seen. `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/200wordsTIL?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#200wordsTIL`}</a><br parentName="p"></br><br parentName="p"></br>{`His talk is great, I wish it was recorded. Here's a recap from memory after 4 beers, 1 cocktail, and 27 hours. 👇`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1086532951829934081"
      }}>{`January 19, 2019`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Today I learned about the Law of Demeter. A law of software architecture that's as old as me. A few months younger maybe. `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/200wordsTIL?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#200wordsTIL`}</a><a parentName="p" {...{
          "href": "https://t.co/PMAqwLYZnf"
        }}>{`https://t.co/PMAqwLYZnf`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1086805930887372801"
      }}>{`January 20, 2019`}</a></blockquote>
    <h1 {...{
      "id": "a-few-cool-things"
    }}>{`A few cool things`}</h1>
    <p>{`Here's some cool stuff I discovered recently 👇`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/asutherland/status/1086488060664131589"
        }}>{`This webMIDI thing projecting notes on a keyboard so you can learn how to play`}</a></li>
      <li parentName="ul">{`Lars Heemskerk shares a `}<a parentName="li" {...{
          "href": "https://twitter.com/larsheemskerk/status/1085046655290753025"
        }}>{`plot of dataviz tools`}</a>{` so you can compare which one is better for your usecase. Pretty neat.`}</li>
      <li parentName="ul">{`Trevor Bedford of `}<a parentName="li" {...{
          "href": "https://nextstrain.org"
        }}>{`nextstrain.org`}</a>{` shares `}<a parentName="li" {...{
          "href": "https://twitter.com/trvrb/status/844289196940410881"
        }}>{`this cool improvement`}</a>{` to how charts on their dashboard interact. You can now better follow how various diseases spread.`}</li>
      <li parentName="ul">{`You should read this post on stoicism and how it applies to your job 👉 `}<a parentName="li" {...{
          "href": "https://codeandtechno.com/posts/stoicism-for-developers/"
        }}>{`If Marcus Aurelius were a software developer`}</a></li>
      <li parentName="ul">{`Dave Ceddia shared a great post about `}<a parentName="li" {...{
          "href": "https://daveceddia.com/path-to-frontend-developer-2019/"
        }}>{`The Path to Becoming a Front End Developer in 2019`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      